import React from 'react';
import { formatPhoneNumber } from 'utils';
import useContact from 'hooks/redux/useContact';
import useGetDirectoryContact from 'hooks/useGetDirectoryContact';

interface Props {}

const Incoming : React.FC<Props> = () => {
        const contact  = useContact();
        const [, name ] = useGetDirectoryContact(contact?.customerEndpointAddress);
        const customer = contact?.customer;

        
        return (
            <div className="dialler-incoming row between">
                <div className="call-details row column">
                    <span className="remote-number">{contact?.customerEndpointAddress ? formatPhoneNumber(contact.customerEndpointAddress) : "UNKNOWN"}</span>
                    {customer?.name || name ? (
                        <span className="remote-name xsm-mar-top">
                            {customer?.name ?? name}
                        </span>
                    ) : null}
                </div>

            </div>
        );
}


export default Incoming
